<template>
  <div>
    <div class="header-top">
      <div class="header-login">
        <div class="welcome">欢迎来到南京电影小镇！</div>
        <div class="login">
          <span v-if="!login" class="login-text">
            <span class="iconfont">&#xe6c1;</span>
            <em @click="loginChange(true, false)">登录</em>
          </span>
          <span class="login-text carmer" v-else>
            <em @click="goOrderList">{{ userInfo.loginName }}</em>
            <a class="ml10" @click="logout()" href="javascript:void(0);"
              >退出</a
            >
          </span>
          <span class="reg-text">
            <em @click="loginChange(true, true)">免费注册</em>
          </span>
        </div>
      </div>
    </div>
    <div class="header-bottom">
      <div class="blank"></div>
      <div class="nav-wrap">
        <div class="nav-inner">
          <ul class="nav-b" v-if="navData">
            <li
              @mouseenter="changeNav(item)"
              @mouseleave="changeNav(item, true)"
              v-for="(item, index) in navData.slice(0, 4)"
              :key="index"
            >
              <span @click="clickNav(item)"> {{ item.title }}</span>

              <div
                :class="[item.isShow ? 'show child' : 'child']"
                v-if="item.list"
              >
                <span
                  v-for="(citem, sindex) in item.list"
                  :key="sindex"
                  @click="gotochild(citem)"
                >
                  {{ citem.title }}
                </span>
              </div>
            </li>
          </ul>
          <i></i>
          <ul class="nav-a" v-if="navData">
            <li
              @mouseenter="changeNav(item)"
              @mouseleave="changeNav(item, true)"
              v-for="(item, index) in navData.slice(4, 7)"
            >
              <span @click="clickNav(item)"> {{ item.title }}</span>

              <div
                :class="[item.isShow ? 'show child' : 'child']"
                v-if="item.list"
              >
                <span
                  v-for="(citem, sindex) in item.list"
                  :key="sindex"
                  @click="gotochild(citem)"
                >
                  {{ citem.title }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState,mapMutations } from "vuex";
import api from "@/api/api";
import { apiGet, apiPost } from "@/fetch/api";

export default {
  name: "privateHeader",
  data() {
    return {
      navData: [
        {
          title: "首页",
          isShow: false,
          linkUrl: "home"
        },
        {
          title: "小镇概述",
          isShow: false,
          linkUrl: "information",
          id: 371
        },
        {
          title: "在线预订",
          isShow: false,
          list: [
            {
              title: "门票预定",
              linkUrl: "ticket",
              parent: "在线预订"
            },
            {
              title: "住宿预定",
              linkUrl: "hotel",
              parent: "在线预订"
            },
            {
              title: "演出预定",
              linkUrl: "theatre",
              parent: "在线预订"
            }
          ]
        },
        {
          title: "游玩攻略",
          isShow: false,
          list: [
            {
              title: "住宿",
              parent: "游玩攻略"
            },
            {
              title: "美食",
              parent: "游玩攻略"
            },
            {
              title: "好物",
              parent: "游玩攻略"
            }
          ]
        },
        {
          title: "小镇导览",
          linkUrl: "tourGuide",
          isShow: false
        },
        {
          title: "小镇动态",
          isShow: false,
          list: [
            {
              title: "新闻动态",
              parent: "小镇动态"
            },
            { title: "优惠活动", parent: "小镇动态" }
          ]
        },
        {
          title: "出行锦囊",
          isShow: false,
          list: [
            {
              title: "营业时间",
              parent: "出行锦囊"
            },
            { title: "服务", parent: "出行锦囊" },
            { title: "交通信息", parent: "出行锦囊" },
            { title: "入园须知", parent: "出行锦囊" }
          ]
        }
      ]
    };
  },
  watch: {
    navData(val, newval) {
      console.log("val", val);
      console.log("newval", newval);
    }
  },
  computed: {
    ...mapState(["login", "userInfo", "m_id",''])
  },

  methods: {
    ...mapMutations(['removeTokenInfo']),
    ...mapActions(['setPrivateMask']),
    changeNav(val, flag = false) {
      this.navData.forEach((item, ind) => {
        if (val.title === item.title) {
          if (flag) {
            item.isShow = false;
          } else {
            item.isShow = true;
          }
        } else {
          item.isShow = false;
        }
      });
    },
    // 导航栏点击效果
    clickNav(val) {
      this.navData.forEach((item, ind) => {
        console.log("m_id", this.m_id);

        if (val.title === item.title) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      });
      if (val.linkUrl === "home") {
        this.$router.push("/?m_id=" + this.m_id);
      }
      if (val.linkUrl === "tourGuide") {
        localStorage.setItem("news_title", "小镇导览");
        this.$router.push("/tourGuide");
      }
      if (val.title === "小镇概述") {
        const url = api.main.indexgetContent;
        const params = {
          merchantInfoId: this.m_id,
          isAll: true,
          page: 0,
          limit: 3,
          id: 371
        };
        localStorage.setItem("news_title", "小镇概述");
        apiGet(url, params).then(res => {
          if (Number(res.status) === 200) {
            this.$router.push(
              "/detail/news?pid=" +
                res.data.rows[0].id +
                "&menuId=" +
                res.data.rows[0].infoMenuId
            );
          }
        });
      }
    },
    gotochild(citem) {
      const dataArr = this.navData;
      dataArr.forEach((item, ind) => {
        dataArr[ind].isShow = false;
      });
      this.navData = dataArr;
      console.log(" this.navData", dataArr, this.navData);
      if (citem.linkUrl === "ticket") {
        this.setPrivateMask(true)
        return
        this.$router.push("/list/ticket?m_id=" + this.m_id);
      }
      if (citem.linkUrl === "hotel") {
        this.$router.push("/list/hotel?m_id=" + this.m_id);
      }
      if (citem.linkUrl === "theatre") {
        this.setPrivateMask(true)
        return
        this.$router.push("/list/theatre?m_id=" + this.m_id);
      }
      if (citem.parent === "游玩攻略") {
        localStorage.setItem("news_title", "游玩攻略");
        this.$router.push("/newslist?m_id=" + this.m_id + "&pid=372");
      }
      if (citem.parent === "小镇动态") {
        localStorage.setItem("news_title", "小镇动态");
        this.$router.push("/newslist?m_id=" + this.m_id + "&pid=376");
      }
      if (citem.parent === "出行锦囊") {
        localStorage.setItem("news_title", "出行锦囊");
        this.$router.push("/newslist?m_id=" + this.m_id + "&pid=379");
      }
    },
    goOrderList() {
      this.$parent.goOrderList();
    },
    logout() {
      let _this = this;
      apiGet("/leaguer/api/userLeaguer/manage/leaguerLogout", {
        merchantInfoId: this.$route.query.m_id || localStorage.getItem("m_id")
      }).then(res => {
        if (res.status == 200) {
          // localStorage.clear();
          // localStorage.removeItem("xjsc_login_access_token_2019_3_7");
          this.removeTokenInfo();
          localStorage.removeItem("xjsc_login_userId_2019_3_8");
          // _this.reload();
          location.reload();
          // _this.refresh();
          _this.$Message.success("退出成功!");
          _this.$store.dispatch("updateLogin", false);
        } else {
          _this.$Message.warning(res.message);
        }
      });
      // _this.refresh();
    },
    loginChange(bool, isLoginRegister) {
      this.$parent.loginChange(bool, isLoginRegister)
      // this.$store.state.loginShow = bool;
      // if (isLoginRegister) {
      //   this.$nextTick(() => {
      //     this.$refs.loginModal.loginBtn = isLoginRegister
      //       ? isLoginRegister
      //       : false;
      //   });
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.header-top {
  background: #308ba0;
  height: 35px;
  font-size: 14px;
  line-height: 35px;
  color: #fff;
  .header-login {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .welcome {
      display: inline-block;
    }
    .login {
      display: inline-block;
      .login-text {
        vertical-align: middle;
        margin-right: 10px;
        &.carmer{
          a{
            &.ml10{
              color:#fff;
            }
          }
        }
        em {
          vertical-align: middle;
          font-size: 14px;
          margin-left: 5px;
          font-style: normal;
        }
        span {
          vertical-align: middle;
        }
      }
      .reg-text {
        display: inline-block;
        vertical-align: middle;
        width: 80px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 12.5px;
        overflow: hidden;
        background: #fff;
        color: #308ba0;
        em {
          font-size: 14px;
          font-style: normal;
        }
      }
    }
  }
}

.header-bottom {
  position: relative;
  width: 100%;
  min-width: 1500px;
  z-index: 999;
  .blank {
    display: block;
    height: 118px;
  }
  .nav-wrap {
    .nav-inner {
      width: 1400px;
      margin: 0 auto;
    }
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    margin: 0 auto;
    height: 150px;
    background: url("~@/assets/images/carmer/nav-bg.png") no-repeat center;
    color: #414141;
    i {
      vertical-align: middle;
      margin-top: 15px;
    }
    ul {
      vertical-align: middle;
      font-size: 18px;
      color: #333333;
      li {
        display: inline-block;
        width: 150px;
        height: 115px;
        line-height: 115px;
        text-align: center;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #308ba0;
        }
        &.on {
          color: #308ba0;
        }
        .child {
          position: absolute;
          background: #fff;
          z-index: 9;
          width: 100%;
          display: none;
          span {
            display: block;
            cursor: pointer;
            border-bottom: 1px solid #f0f0f0;
            height: 50px;
            font-size: 18px;
            line-height: 50px;
            text-align: center;
            color: #666;
            &:hover {
              color: #308ba0;
            }
          }
        }
        .show {
          display: block;
        }
      }
      &:first-of-type {
        margin-right: 40px;
      }
      &:last-of-type {
        margin-left: 40px;
      }
    }
    .nav-a {
      display: inline-block;
    }
    i {
      display: inline-block;
      width: 110px;
      height: 100px;

      background: url("~@/assets/images/carmer/nav-i.png") no-repeat center;
      margin-top: 10px;
    }
    .nav-b {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carmerHeader.vue